import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, CheckCircle, Award, Shield, Globe } from 'lucide-react';
import { Button } from '../ui/button';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-alden-green-dark via-alden-green to-alden-green-light text-white py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-black/30 z-0"></div>
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg" 
          alt="Manufacturing"
          className="w-full h-full object-cover opacity-20"
        />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full text-sm font-semibold mb-6 animate-fade-in">
            Turnkey Water, Beverage &amp; Packaging Engineering Solutions
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Complete Turnkey Solutions for <span className="text-yellow-300">Water, Beverage &amp; Packaging Industries</span>
          </h1>
          
          <p className="text-lg sm:text-xl mb-8 text-white/90 leading-relaxed max-w-3xl">
            Mineral water plants (20–200 BPM), RO &amp; wastewater treatment, bottling and packaging machinery — designed, fabricated and commissioned in-house from our Jaipur facility with PAN India service.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4 mb-12">
            <Link to="/contact">
              <Button className="bg-white text-alden-green hover:bg-gray-100 py-6 px-8 text-lg font-semibold shadow-2xl" data-testid="hero-quotation-cta">
                <Mail className="mr-2" />
                Get Project Quotation
              </Button>
            </Link>
            <a href="tel:+919351292512">
              <Button className="bg-alden-navy hover:bg-alden-navy-light text-white py-6 px-8 text-lg font-semibold shadow-2xl" data-testid="hero-engineer-cta">
                <Phone className="mr-2" />
                Talk to an Engineer
              </Button>
            </a>
            <a href="https://wa.me/919351292512?text=Hi, I want to discuss a turnkey plant project" target="_blank" rel="noopener noreferrer">
              <Button className="bg-green-500 hover:bg-green-600 text-white py-6 px-8 text-lg font-semibold shadow-2xl" data-testid="hero-whatsapp-cta">
                <Phone className="mr-2" />
                WhatsApp Us
              </Button>
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-6 items-center">
            {[
              { id: 'badge-1', icon: CheckCircle, text: '200+ Installations' },
              { id: 'badge-2', icon: Award, text: 'In-House Fabrication, Jaipur' },
              { id: 'badge-3', icon: Shield, text: 'SS 304 Food Grade' },
              { id: 'badge-4', icon: Globe, text: 'PAN India Service' }
            ].map((badge) => (
              <div key={badge.id} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
                <badge.icon className="w-5 h-5" />
                <span className="font-semibold text-sm">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Decorative Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48L60 42.7C120 37 240 27 360 26.7C480 27 600 37 720 42.7C840 48 960 48 1080 42.7C1200 37 1320 27 1380 21.3L1440 16V80H1380C1320 80 1200 80 1080 80C960 80 840 80 720 80C600 80 480 80 360 80C240 80 120 80 60 80H0V48Z" fill="white"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
